import * as React from 'react';
import * as styles from './ProjectsList.css';
import { TViewMode } from '../../containers/Projects/types';
import { clsx } from 'clsx';
import { Responsive } from '@cian/ui-kit';
import { VerticalSlider } from '../VerticalSlider';

interface IProjectsListProps {
  list: React.ReactNode;
  showMoreButton: React.ReactNode;
  mode: TViewMode;
}

export function ProjectsList({ list, showMoreButton, mode }: IProjectsListProps) {
  return (
    <>
      <Responsive desktop>
        <div className={styles['list']}>
          <div className={clsx(styles['cards'], mode === 'list' && styles['cards--listed'])}>{list}</div>
          <div className={styles['show-wrapper']}>{showMoreButton}</div>
        </div>
      </Responsive>

      <Responsive phone tablet>
        <div className={styles['slider']}>
          <VerticalSlider arrow={() => null} containerClass={styles['slider-list']}>
            {list}
          </VerticalSlider>
        </div>
        <div className={styles['show-wrapper']}>{showMoreButton}</div>
      </Responsive>
    </>
  );
}
